import AutomationMutations from './mutations-types'
import i18n from '@/i18n.js'

export default {
  [AutomationMutations.SET_AUTOMATION_TRIGGERS](state, triggers) {
    const field = state.fields.find(field => field.name === 'automation_trigger')
    const selectedTriggers = state.selectedAutomation
      ? [state.selectedAutomation.automation_trigger, field.value].filter(Boolean)
      : []

    field.items = [...new Set([...triggers, ...selectedTriggers])].map(trigger => ({
      text: i18n.t(trigger),
      value: trigger
    }))
  },

  [AutomationMutations.SET_AUTOMATIONS](state, automations) {
    state.automations = [...automations]
  },

  [AutomationMutations.SET_SELECTED_AUTOMATION](state, automation) {
    state.selectedAutomation = automation

    state.fields.forEach((field) => {
      field.value = field.name === 'active' ? true : null

      if (automation) {
        field.value = automation[field.name]
      }
    })

    const triggerField = state.fields.find(field => field.name === 'automation_trigger')
    const trigger = automation && automation.automation_trigger
    if (trigger && !triggerField.items.some(item => item.value === trigger)) {
      triggerField.items.push({ text: i18n.t(trigger), value: trigger })
    }
  },

  [AutomationMutations.SET_FIELD_TENANTS](state, tenants) {
    state.fields.find(f => f.name == 'tenant_id').items = tenants
  },

  [AutomationMutations.SET_TENANT_PERMISSIONS](state, { isMaster, tenants }) {
    const tenantIdField = state.fields.find(f => f.name === 'tenant_id');
    const automationKeyField = state.fields.find(f => f.name === 'automation_key');
    const pipelineIdField = state.fields.find(f => f.name === 'pipeline_id');
    const isEditing = !!state.selectedAutomation;
    
    // Handle automation key field
    if (automationKeyField) {
      if (isEditing) {
        // Disable the field when editing (not hide it)
        automationKeyField.disabled = true;
        automationKeyField.readonly = false;
        automationKeyField.autofocus = false;
      } else {
        // Enable the field when creating new automation
        automationKeyField.disabled = false;
        automationKeyField.readonly = false;
        automationKeyField.autofocus = true;
      }
    }
    
    // Handle pipeline_id field focus
    if (pipelineIdField) {
      if (isEditing) {
        // Set autofocus to pipeline_id when editing
        pipelineIdField.autofocus = true;
      } else {
        // Remove autofocus from pipeline_id when creating new
        pipelineIdField.autofocus = false;
      }
    }
    
    // Handle tenant field
    if (tenantIdField) {
      if (isMaster) {
        tenantIdField.value = null;
        if (isEditing) {
          tenantIdField.disabled = true;
        } else {
          tenantIdField.disabled = true;
        }
      } else if (!isMaster && tenants && tenants.length > 0) {
        if (!state.selectedAutomation) {
          tenantIdField.value = tenants[0].tenant_id;
        }
        
        if (isEditing) {
          tenantIdField.readonly = true;
        } else {
          tenantIdField.disabled = false;
          tenantIdField.readonly = false;
        }
        tenantIdField.required = true;
      }
    }
  }
}
